import gql from 'graphql-tag';

export const GET_ROLES = gql`
  query getRoles {
    rows: ri_apps_prd_roles {
      role_id
      name
      code
    }
  }
`;

export const ADD_USER_ROLES = gql`
  mutation addUserRoles($data: [ri_apps_prd_user_roles_insert_input!]!) {
    rows: insert_ri_apps_prd_user_roles(objects: $data) {
      affected_rows
    }
  }
`;

export const DELETE_USER_ROLES = gql`
  mutation deleteUserRoles($user_id: Int!, $ids: [Int!]!) {
    rows: delete_ri_apps_prd_user_roles(
      where: { user_id: { _eq: $user_id }, role_id: { _in: $ids } }
    ) {
      affected_rows
    }
  }
`;
